import React from "react";
import { Modal, Button, Typography } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { Pencil } from "lucide-react";
import { useNavigate } from "react-router-dom";

const OrderConfirmationModal = ({
  open,
  onCancel,
  onConfirm,
  loading = false,
  totalPrice,
  totalItems
}) => {
    const navigate = useNavigate();
    const { Text } = Typography;

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      centered
      footer={null}
      closable={false}
      width={450}
      styles={{
        content: {
          borderRadius: "12px",
          padding: 0,
          overflow: "hidden",
        },
      }}
    >
      <div className="p-6">
        <div className="flex items-center justify-between mb-5">
          <h2 className="text-[20px] font-semibold text-[#111827] m-0">
          </h2>
          <Button
              type="text"
              icon={<CloseOutlined className="text-[20px]" />}
              onClick={onCancel}
            />
        </div>

        {/* <div className="flex justify-center mb-5">
          <div className="w-[56px] h-[56px] rounded-full bg-[#EEF2FF] flex items-center justify-center">
            <span className="text-[#001997] text-[28px] font-semibold">
              ?
            </span>
          </div>
        </div>

        <div className="text-center">
          <h3 className="text-[17px] font-semibold text-[#1F2937] mb-2">
            Confirm Order ?
          </h3>

          <p className="text-[14px] text-[#6B7280] leading-6 m-0">
            Are you sure you want to place this order?
          </p>
        </div>
        <div className="px-4 py-3 bg-white border-t border-[#e5e7eb]">
                    <div className="flex items-center justify-between gap-6">
                      <div className="flex flex-col">
                        <Text className="text-[12px] text-[#6B7280]">
                          Total Items
                        </Text>
                        <Text strong className="text-[16px] text-[#111827]">
                          {totalItems ?? 0}
                        </Text>
                      </div>

                      <div className="flex flex-col items-end">
                        <Text className="text-[12px] text-[#6B7280]">
                          Total Cost
                        </Text>
                        <Text
                          strong
                          className="text-[20px] font-bold text-[#222]"
                        >
                          ${" "}
                          {totalPrice}
                        </Text>
                      </div>
                    </div>
                  </div> */}

                  <div className="flex justify-center mb-5">
  <div className="w-[48px] h-[48px] rounded-full border-4 border-[#0066FF] flex items-center justify-center">
    <span className="text-[#0066FF] text-[26px] font-bold leading-none">
      ?
    </span>
  </div>
</div>

<div className="text-center">
  <h3 className="text-[17px] font-semibold text-[#111827] mb-3">
    Confirm Order
  </h3>

  <p className="text-[14px] text-[#6B7280] leading-5 m-0">
    Are you sure you want to place this order?
  </p>
</div>

<div className="flex items-center justify-center mt-5 text-[14px]">
  <span className="text-[#6B7280]">Total items:</span>
  <span className="text-[#374151] font-medium ml-1">
    {totalItems ?? 0}
  </span>

  <span className="mx-5 text-[#9CA3AF]">|</span>

  <span className="text-[#6B7280]">Total cost:</span>
  <span className="text-[#374151] font-medium ml-1">
    ${totalPrice?.toFixed(2)}
  </span>
</div>

        <div className="flex gap-3 mt-7">
          <Button
            block
            size="large"
            onClick={onCancel}
            className="!h-[42px] !border-[#D1D5DB] !text-[#374151] hover:!border-[#001997] hover:!text-[#001997]"
          >
            Cancel
          </Button>

          <Button
            block
            size="large"
            loading={loading}
            onClick={onConfirm}
            className="!h-[42px] !bg-[#001997] hover:!bg-[#061561] !text-white !border-none"
          >
            Place Order
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default OrderConfirmationModal;